import React from "react";
import Typewriter from "typewriter-effect";
import "./style.css";

const ComingSoon = () => {
  return (
    <div className="maindiv">
        <div className="text-white text-center dashboard">
      {/* <img
        src={`${process.env.PUBLIC_URL}/images/logo2.png`}
        alt="Glasses"
        className="specs"
      />
      */}
      <div className="my-4">
      {/* <img
        src={`${process.env.PUBLIC_URL}/images/logo2.png`}
        alt="Glasses"
        className="specs"
      /> */}
      </div>
      <div className="my-6">
        <img
          src={`${process.env.PUBLIC_URL}/images/1.png`}
          alt="Glasses"
          className="specs2"
        />
      </div>
      <h2 className="font-bold color-white comingsoon">
        <Typewriter
          options={{
            strings: ["COMING SOON"],
            autoStart: true,
            loop: true,
            delay: 100,
          }}
        />
      </h2>
    </div>
    </div>
  );
};

export default ComingSoon;
